<div class="form-group-query">
    <div [style]="props['labelstyle']">
        <label>{{to.label}}</label>
    </div>
    <div style="margin-left:10px">
        <input (click)="manageCheck();$event.preventDefault();" type="checkbox" [checked]="isChecked" />
    </div>
    <div style="margin-left:10px" (click)="openModal()">
        <input (ngModelChange)="onInputChange()" [readonly]="!isChecked" class="ml-5 form-control" type="text" [formControl]="formControl" [formlyAttributes]="field" #value />
    </div>
    <div>
        <span style="margin-left:15px">{{ text }}</span>
    </div>
</div>